exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li[data-v-e2614d42]{list-style-type:none;margin-top:20px}label[data-v-e2614d42]{font-weight:700}span.hint[data-v-e2614d42]{font-size:12px;font-style:italic}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e2614d42","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AddCustomer.vue
// module id = 302
// module chunks = 0